import militaryOffice from './components/militaryOffice';

export default {
  routes: [
    {
      path: '/',
      component:militaryOffice,
      name:'militaryOffice'
    },
  ]
};
